module.exports = __webpack_public_path__ + "static/img/h-first.179a4c03.png";